import { render, staticRenderFns } from "./ItemNavigator.vue?vue&type=template&id=6437cdfa"
import script from "./ItemNavigator.vue?vue&type=script&lang=js"
export * from "./ItemNavigator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports